
export function reflow (element: HTMLElement) {
  element.offsetHeight
}
